import { render } from "./ListeDemandeCommandePage.vue?vue&type=template&id=5608ce2a&ts=true"
import script from "./ListeDemandeCommandePage.vue?vue&type=script&lang=ts"
export * from "./ListeDemandeCommandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__